export const SessionState = {
  Active: 'Active',
  Disconnected: 'Disconnected',
  Pending: 'Pending',
  LogOff: 'LogOff',
  UserDisconnected: 'UserDisconnected'
} as const;

export type SessionState = typeof SessionState[keyof typeof SessionState];

export interface Session {
  id: string;
  userId: string;
  userPrincipalName: string;
  hostPoolName: string;
  sessionHostName: string;
  sessionState: SessionState;
  startTime: string;
  lastActivityTime?: string;
  applicationType: string;
  clientIPAddress?: string;
  isOrphaned: boolean;
  lastHealthCheck?: string;
}

export interface DisconnectRequest {
  reason?: string;
}

export interface LogOffRequest {
  reason?: string;
}

export interface SessionStatusResponse {
  sessionId: string;
  state: string;
  lastActivityTime?: string;
  isActive: boolean;
}

export interface ApiError {
  error: string;
  message?: string;
}

// Admin types
export interface AdminSessionActionRequest {
  hostPoolName: string;
  sessionHostName: string;
}

export interface AdminSessionMessageRequest extends AdminSessionActionRequest {
  messageTitle: string;
  messageBody: string;
}

export interface BulkSessionRequest {
  sessionId: string;
  hostPoolName: string;
  sessionHostName: string;
}

export interface BulkSessionActionRequest {
  action: 'disconnect' | 'logoff' | 'message';
  sessions: BulkSessionRequest[];
  messageTitle?: string;
  messageBody?: string;
}

export interface BulkActionResult {
  sessionId: string;
  success: boolean;
  message: string;
}

export interface BulkActionResponse {
  message: string;
  results: BulkActionResult[];
}

export interface SessionFilters {
  username?: string;
  hostPool?: string;
  sessionHost?: string;
  sessionState?: SessionState;
  orphanedOnly?: boolean;
}

export interface AdminSession extends Session {
  selected?: boolean;
}